import React from "react";
import Section from "../Section";
import { NewsList } from "../../Data/NewsList";
import { useNavigate } from "react-router-dom";
import { delayNavigation } from "../../helpers/helpers";
import { useDispatch } from "react-redux";

const MainSectionHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <Section bg="bg-inherit">
      <header className="col-span-10 col-start-2 grid grid-cols-12 gap-8 ">
        <div className="col-span-full text-primary-bg-blue ">
          <h2 className="font-gilroy text-6xl tracking-wider py-24 leading-4">
            მედია
          </h2>
          <div className="h-[2px] bg-black opacity-30 w-full" />
        </div>
      </header>
      <div className="col-span-10 col-start-2 grid grid-cols-10 md:gap-y-16 py-16 xl:py-32">
        {NewsList.sort((a, b) => new Date(b.date) - new Date(a.date)).map(
          (news, index) => {
            return (
              <div
                key={news.id}
                className={`col-span-full flex flex-col ${
                  index % 2 === 0 ? "xl:flex-row-reverse" : "xl:flex-row"
                } items-center justify-between gap-y-8 xl:gap-y-0 xl:py-8 `}
              >
                <div className="w-full xl:w-1/2 h-96 flex items-center justify-center">
                  <img
                    src={news.img}
                    alt="news"
                    className="w-full h-full object-cover object-center "
                  />
                </div>
                <div
                  className={`w-full xl:w-1/2 h-full flex flex-col items-start justify-start gap-8 ${
                    index % 2 === 0 ? "xl:pr-32" : "xl:pl-32"
                  } `}
                >
                  <h2
                    className="text-3xl tracking-wide font-gilroy text-primary-bg-blue/80 hover:text-primary-bg-blue transform transition-all duration-150 ease-in-out cursor-pointer"
                    onClick={() =>
                      delayNavigation(
                        dispatch,
                        navigate,
                        `/news/${news.pathName}`
                      )
                    }
                  >
                    {news.header}
                  </h2>
                  <div className="flex items-center justify-start gap-3 text-sm font-bold">
                    <span className="px-3 py-1 bg-primary-orange text-primary-light rounded-lg">
                      {news.type}
                    </span>
                    <span className="text-primary-orange">{news.date}</span>
                  </div>
                  {/* <div
                    dangerouslySetInnerHTML={{
                      __html: news.text.slice(0, 255),
                    }}
                    className="text-primary-bg-blue"
                  /> */}
                  <p className="text-primary-bg-blue">{news.unstyledText}</p>
                  <a
                    href={`/news/${news.pathName}`}
                    onClick={(event) => {
                      delayNavigation(
                        dispatch,
                        navigate,
                        `/news/${news.pathName}`,
                        event
                      );
                    }}
                    className="relative text-primary-orange uppercase text-lg font-bold tracking-wider  bg-transparent no-underline opacity-100 transform transition-all duration-[0.45s] ease-out delay-[0.6s] flex flex-col justify-center items-center whitespace-nowrap cursor-pointer group"
                  >
                    დეტალურად ...
                    <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-primary-orange transition-all duration-500 group-hover:w-full"></span>
                  </a>
                </div>
              </div>
            );
          }
        )}
        {/* <p className="col-span-full text-2xl tracking-wider font-semibold text-primary-bg-blue">
          გახდით ჩვენი გამომწერი
        </p> */}
      </div>
    </Section>
  );
};

export default MainSectionHeader;
